import { Button, Col, Input, message, Row, Space, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import {
  displayFormattedDate,
  formatCurrency,
  isEmpty,
} from "../../../generalFunctions";
import useApi from "../../../hooks/useApi";
import TableComponent from "../../common/table/TableComponent";
import AddDirectPurchase from "./AddDirectPurchase";
import { EditOutlined, EyeOutlined, PrinterOutlined } from "@ant-design/icons";

function DirectPurchaseTable(props) {
  const columns = [
    { tittle: "Number", dataIndex: "id" },
    {
      title: "Creditor",
      dataIndex: "creditor",
    },
    {
      title: "Bill Date",
      dataIndex: "billDate",
      render: (text) => displayFormattedDate(text),
    },
    {
      title: "Bill Number",
      dataIndex: "billNumber",
    },
    {
      title: "Narration",
      dataIndex: "narration",
    },
    {
      title: "Bill Amount",
      dataIndex: "billAmount",
      render: (text) => formatCurrency(text),
    },
    {
      title: "Action",
      key: "action",

      render: (text, record) => (
        <Space>
          <Button size="small" onClick={() => editRecord(record)}>
            <EditOutlined />
          </Button>
          <Button size="small" onClick={() => editRecord(record, true)}>
            <EyeOutlined />
          </Button>
        </Space>
      ),
    },
  ];

  const [responseData, getRequest] = useApi(
    "/directPurchase",
    null,
    API_METHODS.GET
  );
  const [visible, setVisible] = useState(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [tableData, setTableData] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [singleGetResponse, singleGetRequest] = useApi(
    `/directPurchase/`,
    null,
    API_METHODS.GET
  );

  useEffect(() => {
    getRequest(null, API_METHODS.GET, `/directPurchase?pageNumber=${1}`);
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    setTotalRecords(data && data.length > 0 ? data[0].count : 0);
    setTableData(data);
  }, [responseData]);

  useEffect(() => {
    if (
      singleGetResponse &&
      !isEmpty(singleGetResponse.data) &&
      !singleGetResponse.isLoading
    ) {
      const { data } = singleGetResponse;
      setIsViewOnly(true);
      setVisibleEdit(true);
      setSelectedRecord(data[0]);
    } else if (
      singleGetResponse &&
      singleGetResponse.data === BLANK_VALUE &&
      !singleGetResponse.isLoading
    ) {
      message.error("Direct Purchase not found");
    }
  }, [singleGetResponse]);

  const onDirectPurchaseSearch = (id) => {
    if (!isEmpty(id))
      singleGetRequest(null, API_METHODS.GET, `/directPurchase/${id}`);
  };

  const handleAddDirectPurchase = (isUpdated) => {
    const flag = visible ? false : true;
    setVisible(flag);
    if (isUpdated === true) {
      getRequest(null, API_METHODS.GET, `/directPurchase?pageNumber=${1}`);
    }
  };

  const handleEditDirectPurchase = (isUpdated) => {
    const flag = visibleEdit ? false : true;
    !flag && setSelectedRecord(null);
    setVisibleEdit(flag);
    if (isUpdated === true) {
      getRequest(null, API_METHODS.GET, `/directPurchase?pageNumber=${1}`);
    }
  };

  const editRecord = (record, isViewOnly = false) => {
    setIsViewOnly(isViewOnly);
    setVisibleEdit(true);
    setSelectedRecord(record);
  };

  const onPaginationChange = (page) => {
    getRequest(
      null,
      API_METHODS.GET,
      `/directPurchase?pageNumber=${page.current}`
    );
    setCurrentPage(page.current);
  };

  return (
    <>
      <Row>
        <Col span={6}>
          <Typography.Title level={5}>Direct Purchases</Typography.Title>
        </Col>
        <Col span={18}>
          <Space style={{ marginBottom: 10, float: "right" }}>
            {/* <Input.Search
              placeholder="Direct Purchase Number"
              allowClear
              enterButton="Search"
              onSearch={onDirectPurchaseSearch}
            /> */}
            <Button type="primary" onClick={handleAddDirectPurchase}>
              Add Direct Purchase
            </Button>
          </Space>
        </Col>
      </Row>
      <TableComponent
        columns={columns}
        tableData={tableData}
        loading={responseData.isLoading}
        onPaginationChange={onPaginationChange}
        total={totalRecords}
        current={currentPage}
      />
      {visible && (
        <AddDirectPurchase visible={visible} close={handleAddDirectPurchase} />
      )}
      {visibleEdit && (
        <AddDirectPurchase
          visible={visibleEdit}
          selectedRecord={selectedRecord}
          close={handleEditDirectPurchase}
          isViewOnly={isViewOnly}
        />
      )}
    </>
  );
}

export default DirectPurchaseTable;
